import { useState } from "react";
import styles from "./Sidebar.module.scss";
import { NavLink } from "react-router-dom";
import { links } from "../../utils/routes.js";
import { FaCaretDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import useMediaQuery from "@mui/material/useMediaQuery";
export default function Sidebar({ clickHandler, visible }) {
  const [data, setData] = useState(links);
  const matches = useMediaQuery("(min-width:1200px)");
  const setActive = (e) => {
    let name = e.currentTarget.id;

    const newState = data.map((obj) => {
      if (obj.name === name) {
        return { ...obj, active: !obj.active };
      }
      return obj;
    });

    setData(newState);
  };
  const clickFunction = () => {
    if (!matches) clickHandler();
  };
  const removeActive = () => {
    const newState = data.map((obj) => {
      if (obj.active === true) {
        return { ...obj, active: !obj.active };
      }
      return obj;
    });

    setData(newState);
  };

  return (
    <aside className={visible ? `` : `${styles.invisible}`}>
      <Link className={styles.logo} to="/">
        <img src={logo} alt="Gordon Logo" />
      </Link>
      <div className={styles.linksWrapper}>
        {data.map((link, index) =>
          link.dropdown ? (
            <div key={index} className={styles.dropdownWrapper}>
              <div
                id={link.name}
                className={`${styles.link} ${
                  !link.active ? `` : `${styles.active}`
                }`}
                onClick={setActive}
              >
                {link.icon}
                <span>{link.name}</span>
                <span
                  style={
                    visible
                      ? { marginLeft: "auto", display: "flex" }
                      : { marginLeft: "auto", display: "none" }
                  }
                >
                  <FaCaretDown />
                </span>
              </div>
              <div
                className={`${styles.dropdown} ${
                  !link.active ? `` : `${styles.activeDropdown}`
                }`}
              >
                {link.dropdown.map((item, index) => (
                  <NavLink
                    key={index}
                    style={({ isActive }) => ({
                      background: isActive ? "#e40521" : "",
                    })}
                    className={({ isActive }) =>
                      isActive
                        ? `${styles.link} ${styles.childActive}`
                        : `${styles.link}`
                    }
                    to={item.path}
                    onClick={clickFunction}
                  >
                    <span className={styles.smallicon}>{item.icon}</span>
                    <span>{item.name}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          ) : (
            <div
              className={styles.dropdownWrapper}
              key={index}
              onClick={removeActive}
            >
              <NavLink
                style={({ isActive }) => ({
                  background: isActive ? "#e40521" : "",
                })}
                to={link.path}
                onClick={clickFunction}
                id={link.path}
                className={styles.link}
              >
                {link.icon}
                <span>{link.name}</span>
              </NavLink>
            </div>
          )
        )}
      </div>
      {/* <div className={styles.logout} onClick={Logout}>
        <img alt="logout icon" src={logout} />
        <span>Wyloguj</span>
      </div> */}
    </aside>
  );
}
